import React from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import { FeatureProp } from '../PropTypes/StandardFeatureProp.js';
import { FeatureCategoryItems } from './FeatureCategoryItems';

const createPanelGroupClassName = (widgetHeading, toggleCollapse) => {
	let panelGroupClass = 'standard-feature-category m-0 mb-5 mb-sm-6';

	if (widgetHeading && toggleCollapse === 'true') {
		panelGroupClass = `${panelGroupClass} mx-5`;
	}
	return panelGroupClass;
};

export default class FeatureCategory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: false
		};
		this.toggleExpand = this.toggleExpand.bind(this);
	}

	toggleExpand() {
		this.setState((state) => {
			return { isExpanded: !state.isExpanded };
		});
	}

	createPanelHeader(feature, panelHeadingWeight, panelHeadingCase) {
		const icon = this.state.isExpanded ? 'collapse' : 'expand';
		return (
			<h4>
				<div className={`${panelHeadingWeight} ${panelHeadingCase}`}>
					<i
						className={`ddc-icon icon-style-collapse ddc-icon-${icon} d-inline mr-3`}
					/>
					{feature.packageName}
				</div>
			</h4>
		);
	}

	render() {
		return (
			<Common
				render={({ prefs }) => {
					const { feature } = this.props;

					const {
						widgetHeading,
						toggleCollapse,
						panelHeadingWeight,
						panelHeadingCase
					} = prefs;

					const panelHeader = this.createPanelHeader(
						feature,
						panelHeadingWeight,
						panelHeadingCase
					);
					const panelGroupClass = createPanelGroupClassName(
						widgetHeading,
						toggleCollapse
					);

					return (
						<PanelGroup className={panelGroupClass.trim()}>
							<Panel
								className="border-0 p-0"
								onToggle={this.toggleExpand}
							>
								<Panel.Heading>
									<Panel.Title toggle>
										{panelHeader}
									</Panel.Title>
								</Panel.Heading>
								<Panel.Collapse>
									<Panel.Body>
										<FeatureCategoryItems
											options={feature.options}
										/>
									</Panel.Body>
								</Panel.Collapse>
							</Panel>
						</PanelGroup>
					);
				}}
			/>
		);
	}
}

FeatureCategory.propTypes = {
	feature: FeatureProp.isRequired
};
